import { render, staticRenderFns } from "./ViAdhocfees.vue?vue&type=template&id=05df2921"
import script from "./ViAdhocfees.vue?vue&type=script&lang=js"
export * from "./ViAdhocfees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports